<div id="file-uploader">
    <label class="d-flex align-items-center flex-nowrap mat-caption" [attr.for]="id" *ngIf="label">
        <img [src]="iconPath" width="24" class="mr-2" *ngIf="iconPath" />
        <span>{{ label }}</span>
    </label>
    <input
        type="file"
        class="custom-file-input"
        [id]="id"
        [name]="name"
        [accept]="accept"
        [required]="required"
        [disabled]="disabled || readonly"
        (change)="onInputChange($event)"
    />
    <div class="custom-file-control" [class.readonly]="readonly">
        <div class="custom-file-label">
            <span>{{ filename || '&nbsp;' }}</span>

            <div class="actions" *ngIf="filename">
                <button type="button" mat-icon-button (click)="onView()" *ngIf="canView">
                    <i class="icon-eye"></i>
                </button>
                <button type="button" mat-icon-button (click)="onRemove()" *ngIf="canRemove && !disabled">
                    <i class="icon-delete"></i>
                </button>
            </div>
        </div>

        <button
            type="button"
            class="custom-file-button mat-elevation-z0"
            mat-raised-button
            color="gray"
            [disabled]="disabled"
            (click)="onSelect()"
            *ngIf="!readonly"
        >
            {{ 'general.select-file' | translate }}
        </button>
    </div>
</div>
